import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ExploreMapService } from '../../explore-map.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
})
export class LegendComponent implements OnInit, OnDestroy {
  @Input() activeMapProxyLayername: any;
  @Input() mapServiceName: any;
  legendImageSrc: string = '';
  layerName: string = '';
  onDestroy$ = new Subject();

  constructor(private exploreMapService: ExploreMapService, private sanitizer: DomSanitizer) {}

  /**
   * Listen for changes in the feature
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeMapProxyLayername) {
      this.initLegend(this.activeMapProxyLayername);
    }
  }

  ngOnInit() {}

  initLegend(layerName: string): void {
    this.exploreMapService
      .getLegendGraphic(layerName)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) => {
          let imageUrl = URL.createObjectURL(data);
          this.legendImageSrc = this.sanitizer.bypassSecurityTrustUrl(imageUrl) as string;
        },
        error: (err) => {
          console.log(err);
        },
        complete: () => {},
      });
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
